module.exports = __webpack_public_path__ + "img/the-safe.2b44a859.png";